import { Typography, Box, useTheme, TextField, Switch, Divider, MenuItem, FormControlLabel, Checkbox, Autocomplete, Button, Grid, Dialog, Tooltip, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import { toast } from 'react-toastify';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import AddCircleIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import 'react-toastify/dist/ReactToastify.css';
import CallAlertBar from "../../Layout/Alertbar";
import { tokens } from "../../theme/theme";
import { callApi } from "../../utils/apiClient";
import Cancel from '@mui/icons-material/Cancel';
import { API_ENDPOINTS } from "../../config/api/apiCall";
import useMaterialCategory from "../../hooks/useMaterialCategory";
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import useMaterialShades from "../../hooks/useMaterialShades";
import DeleteForeverIcon from '@mui/icons-material/HighlightOff';
import { Addchart, Delete, Edit } from "@mui/icons-material";
import useMaterialSubCategory from "../../hooks/useMaterialSubCategory";
import ResponsiveBox from "../../components/form/ResponsiveScrollBox";
import CategoryIcon from '@mui/icons-material/Category';
	import BuildIcon from '@mui/icons-material/Build';
		import AddCircle from '@mui/icons-material/AddCircle';
import SettingsIcon from '@mui/icons-material/Settings';
const dataTypes = ["text", "number", "boolean", "date"];
const uiTypes = ["textbox", "dropdown", "checkbox", "date"];

const AddUpdateMaterialAttributes = ({ onClose, handleBackWinderMachineEntry, open }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [result, setresult] = useState([]);
    const [selectedShade, setSelectedShade] = useState(null);
    //message are 
    const [openDialog, setOpenDialog] = useState(false);
    const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
    const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
    const [parentRollMessageValue, setParentRollMessageValue] = useState('');
    const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');
    // Custom hook to manage material shades
    const [attributes, setAttributes] = useState([]);
    const { materialCategory, selectedCategory, selectedCategoryID, setSelectedCategory, setSelectedCategoryID, loadMaterialCategoryByID } = useMaterialCategory(0);
    const { materialSubCategory, selectedSubCategory, selectedSubCategoryID, setSelectedSubCategory, setSelectedSubCategoryID, loadMaterialSubCategoryByID } = useMaterialSubCategory(0);

    const [formData, setFormData] = useState({
        id_attribute: null,
        id_category: "",
        attribute_name: "",
        data_type: "text",
        is_required: false,
        ui_label: "",
        ui_type: "textbox",
        is_active: true,
        id_sub_category: null

    });

    const fetchAttributes = async () => {
        const requestBody = {
            // IdCategory: selectedCategoryID === 0 ? null : selectedCategoryID
            IdCategory: null,
            IdSubCategory: null
        };

        callApi(API_ENDPOINTS.MATERIAL_ATTRIBUTE_GET_LIST, 'POST', { 'Content-Type': 'application/json' }, requestBody)
            .then(data => {
                if (data && data.length > 0) {
                    setAttributes(data);
                }
            })
            .catch(error => {
                alert(error.message);
            });
    };
    useEffect(() => {
        fetchAttributes();
    }, []);

    const handleOpen = (row = null) => {
        if (row) {
            setFormData(row);
            setSelectedCategoryID(row.id_category);
            setSelectedCategory({ id_material_category: row.id_category, description: row.category_name, });
            loadMaterialCategoryByID(row.id_category);
            loadMaterialSubCategoryByID(row.id_category, row.id_sub_category);

            setSelectedSubCategoryID(row.id_subcategory);
            setSelectedSubCategory({ id_material_subcategory: row.id_subcategory, description: row.subcategory, });

        } else {
            setFormData({
                id_attribute: null,
                id_category: "",
                attribute_name: "",
                data_type: "text",
                is_required: false,
                ui_label: "",
                ui_type: "textbox",
                is_active: true,
                id_sub_category: null
            });
        }
        setOpenDialog(true);
    };


    const handleClose = () => handleBackWinderMachineEntry();

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleSave = async () => {

        // 🛡️ Validation
        let errors = [];

        if (!formData.id_category) errors.push("Category is required.");
        if (!formData.id_sub_category) errors.push("Subcategory is required.");
        if (!formData.attribute_name || formData.attribute_name.trim() === "") errors.push("Attribute name is required.");
        if (!formData.data_type || formData.data_type.trim() === "") errors.push("Data type is required.");
        if (!formData.ui_type || formData.ui_type.trim() === "") errors.push("UI type is required.");
        if (!formData.ui_label || formData.ui_label.trim() === "") errors.push("UI label is required.");

        if (errors.length > 0) {
            alert(errors.join("\n"));
            return;
        }

        if (!formData.id_attribute) {
            const requestBody = {
                Action: "insert",
                IdCategory: formData.id_category,
                AttributeName: formData.attribute_name,
                DataType: formData.data_type,
                IsRequired: formData.is_required,
                UiLabel: formData.ui_label,
                UiType: formData.ui_type,
                IsActive: formData.is_active,
                IdSubCategory: formData.id_sub_category
            };
            callApi(API_ENDPOINTS.MATERIAL_ATTRIBUTE_CRUD_PROCESS, 'POST', { 'Content-Type': 'application/json' }, requestBody)
                .then(data => {
                    if (data && data.length > 0) {
                        if (data[0] !== 0) {
                            alert("Material Attribute successfully added");
                        } else {
                            alert("Material Attribute not added properly, please try again");
                        }
                    }
                })
                .catch(error => {
                    alert(error.message);
                });

        } else {
            const requestBody = {
                Action: "update",
                IdAttribute: formData.id_attribute,
                IdCategory: formData.id_category,
                AttributeName: formData.attribute_name,
                DataType: formData.data_type,
                IsRequired: formData.is_required,
                UiLabel: formData.ui_label,
                UiType: formData.ui_type,
                IsActive: formData.is_active
            };
            callApi(API_ENDPOINTS.MATERIAL_ATTRIBUTE_CRUD_PROCESS, 'POST', { 'Content-Type': 'application/json' }, requestBody)
                .then(data => {
                    if (data && data.length > 0) {
                        if (Boolean(data[0]) === true) {
                            alert("Material Attribute successfully updated");
                        } else {
                            alert("Material Attribute not updated properly, please try again");
                        }
                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        }
        fetchAttributes();

    };

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure to delete this attribute?")) {
            const requestBody = {
                Action: "delete",
                IdAttribute: id,
            };
            callApi(API_ENDPOINTS.MATERIAL_ATTRIBUTE_CRUD_PROCESS, 'POST', { 'Content-Type': 'application/json' }, requestBody)
                .then(data => {
                    if (data && data.length > 0) {
                        if (data[0] !== 0) {
                            alert("Material Attribute successfully deleted");
                        } else {
                            alert("Material Attribute not deleted properly, please try again");
                        }
                    }
                })
                .catch(error => {
                    alert(error.message);
                });
            fetchAttributes();
            handleClose();
        }
    };

    const columns = [
        { 
            field: "actions",
            headerName: "",
            width: 100,
            renderCell: (params) => (
                <>
                    <Tooltip title="Edit" arrow>
                        <IconButton color="secondary" onClick={() => handleOpen(params.row)}>
                            <Edit />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete" arrow>
                        <IconButton color="error" onClick={() => handleDelete(params.row.id_attribute)}>
                            <DeleteForeverIcon />
                        </IconButton>
                    </Tooltip>
                    
                </>
            ),
        },

        // { field: "id_attribute", headerName: "ID", width: 70 },
        { field: "category", headerName: "Category desc.", width: 200 },
        { field: "attribute_name", headerName: "Attribute Name", width: 150 },
        { field: "data_type", headerName: "Data Type", width: 100 },
        { field: "ui_type", headerName: "UI Type", width: 100 },
        { field: "ui_label", headerName: "Label", width: 150 },
        {
            field: "is_required",
            headerName: "Required",
            width: 100,
            renderCell: (params) => (params.row.is_required ? "Yes" : "No"),
        },

    ];





    return (

        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            PaperProps={{
                style: {
                    alignSelf: 'flex-start',
                    margin: '0 auto',
                    position: 'relative',
                    top: '0px',
                },
            }}
            BackdropProps={{
                style: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    paddingTop: '20px',
                    minHeight: '100vh',
                    background: 'rgba(0,0,0,0.5)',
                },
            }}
        >


            <DialogTitle style={{ backgroundColor: colors.primary[600], color: colors.primary }}>
                <Box display="flex" alignItems="center" justifyContent={"space-between"}>
                    {/* <WarningRoundedIcon style={{ marginRight: 8, color: 'pink', fontSize: "32" }} /> Add icon with some margin */}
                  <Box display="flex" alignItems="center" gap={1}>
   {/* <Tooltip title="Material Attributes Configuration">
  <SettingsSuggestIcon color="secondary" sx={{ fontSize: 24, cursor: 'pointer' }} />
</Tooltip> */}

  <Typography variant="h4">Material Attributes</Typography>
</Box>


{/* <Tooltip title="Close" arrow>
    <IconButton size="small" color="warning" onClick={onClose}>
        <Cancel size="small" />
    </IconButton>
</Tooltip> */}

                </Box>

            </DialogTitle>
            <DialogContent style={{ backgroundColor: colors.primary[500], color: colors.primary }}>
                {/* Your modal content here */}


                <Box>
                    {/* <Header title="Add New Operator" subtitle="" callback={onClose} />
                        <Divider /> */}
                    {/* Message box detail */}
                    <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
                        setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
                        setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />


                    <Grid container  sx={{ width: '100%',  }} >
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}  >
                            <Box
                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(2, 1fr)',
                                    md: 'repeat(12, 1fr)',
                                }}
                                gap={{ xs: 4, md: 5 }}
                                mt={2}
                            >
                                <Box
                                    gridColumn={{ xs: 'span 2', md: 'span 3' }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"
                                >
                                    <Typography variant="h6">Material Category</Typography>
                                </Box>

                                <Box
                                    gridColumn={{ xs: 'span 2', md: 'span 6' }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"
                                >
                                    <Autocomplete
                                        size="small"
                                        fullWidth
                                        options={materialCategory}
                                        value={selectedCategory}

                                        onChange={(event, newValue) => {
                                            setSelectedCategory(newValue);
                                            setSelectedCategoryID(newValue?.id_material_category || null);
                                            setFormData((prev) => ({
                                                ...prev,
                                                id_category: newValue?.id_material_category || "",
                                            }));
                                            if (newValue) {

                                                loadMaterialSubCategoryByID(newValue.id_material_category);
                                            }
                                        }}
                                        getOptionLabel={(option) => option.description || ''}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Select the Material Category" required variant="outlined" color="secondary" />
                                        )}
                                    />
                                </Box>
                            </Box>

                            <Box
                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(2, 1fr)',
                                    md: 'repeat(12, 1fr)',
                                }}
                                gap={{ xs: 4, md: 5 }}
                                mt={2}
                            >
                                <Box
                                    gridColumn={{ xs: 'span 2', md: 'span 3' }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"
                                >
                                    <Typography variant="h6">Material Sub Category</Typography>
                                </Box>

                                <Box
                                    gridColumn={{ xs: 'span 2', md: 'span 6' }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"
                                >
                                    <Autocomplete
                                        size="small"
                                        fullWidth
                                        options={materialSubCategory}
                                        value={selectedSubCategory}
                                        onChange={(event, newValue) => {
                                            setSelectedSubCategory(newValue);
                                            setSelectedSubCategoryID(newValue?.id_material_subcategory || null);
                                            setFormData((prev) => ({
                                                ...prev,
                                                id_sub_category: newValue?.id_material_subcategory || "",
                                            }));
                                        }}
                                        getOptionLabel={(option) => option.description || ''}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Select the Material Sub Category" required variant="outlined" color="secondary" />
                                        )}
                                    />
                                </Box>
                            </Box>

                            <Box
                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(2, 1fr)',
                                    md: 'repeat(12, 1fr)',
                                }}
                                gap={{ xs: 4, md: 5 }}
                                mt={2}
                            >
                                <Box
                                    gridColumn={{ xs: 'span 2', md: 'span 3' }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"
                                >
                                    <Typography variant="h6">Attribute Name</Typography>
                                </Box>

                                <Box
                                    gridColumn={{ xs: 'span 2', md: 'span 6' }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"
                                >
                                    <TextField
                                        size="small"
                                        color="secondary"
                                        required
                                        label="Enter Attribute Name"
                                        name="attribute_name"
                                        value={formData.attribute_name}
                                        onChange={handleChange}
                                        fullWidth
                                    />
                                </Box>
                            </Box>


                            <Box
                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(2, 1fr)',
                                    md: 'repeat(12, 1fr)',
                                }}
                                gap={{ xs: 4, md: 5 }}
                                mt={2}
                            >
                                <Box
                                    gridColumn={{ xs: 'span 2', md: 'span 3' }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"
                                >
                                    <Typography variant="h6">Data Type</Typography>
                                </Box>

                                <Box
                                    gridColumn={{ xs: 'span 2', md: 'span 6' }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"
                                >
                                    <TextField size="small" required color="secondary" select label="Select Data Type" name="data_type" value={formData.data_type} onChange={handleChange} fullWidth>
                                        {dataTypes.map((dt) => <MenuItem key={dt} value={dt}>{dt}</MenuItem>)}
                                    </TextField>
                                </Box>
                            </Box>


                            <Box
                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(2, 1fr)',
                                    md: 'repeat(12, 1fr)',
                                }}
                                gap={{ xs: 4, md: 5 }}
                                mt={2}
                            >
                                <Box
                                    gridColumn={{ xs: 'span 2', md: 'span 3' }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"
                                >
                                    <Typography variant="h6">UI Type</Typography>
                                </Box>

                                <Box
                                    gridColumn={{ xs: 'span 2', md: 'span 6' }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"
                                >
                                    <TextField size="small" required color="secondary" select label="Select UI Type" name="ui_type" value={formData.ui_type} onChange={handleChange} fullWidth>
                                        {uiTypes.map((ui) => <MenuItem key={ui} value={ui}>{ui}</MenuItem>)}
                                    </TextField>
                                </Box>
                            </Box>


                            <Box
                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(2, 1fr)',
                                    md: 'repeat(12, 1fr)',
                                }}
                                gap={{ xs: 4, md: 5 }}
                                mt={2}
                            >
                                <Box
                                    gridColumn={{ xs: 'span 2', md: 'span 3' }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"
                                >
                                    <Typography variant="h6">UI Label</Typography>
                                </Box>

                                <Box
                                    gridColumn={{ xs: 'span 2', md: 'span 6' }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"
                                >
                                    <TextField size="small" required color="secondary" label="Enter UI Label" name="ui_label" value={formData.ui_label} onChange={handleChange} fullWidth />
                                </Box>
                            </Box>



                            <Box
                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(2, 1fr)',
                                    md: 'repeat(12, 1fr)',
                                }}
                                gap={{ xs: 4, md: 5 }}
                                mt={2}
                            >
                                <Box
                                    gridColumn={{ xs: 'span 2', md: 'span 3' }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"
                                >

                                </Box>


                                <Box
                                    gridColumn={{ xs: 'span 2', md: 'span 9' }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"
                                    gap={2}
                                >
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                size="small"
                                                color="secondary"
                                                checked={formData.is_required}
                                                onChange={handleChange}
                                                name="is_required"
                                            />
                                        }
                                        label="Is Required?"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                size="small"
                                                color="secondary"
                                                checked={formData.is_active}
                                                onChange={handleChange}
                                                name="is_active"
                                            />
                                        }
                                        label="Is Active?"
                                    />
                                </Box>
                            </Box>





                            <Box marginTop={0}>
                                <Box display="flex" justifyContent="flex-end">

                                    {/* <Button onClick={() => handleOpen()} size="small" variant="contained" color="secondary">
                                        Add Attribute
                                    </Button> */}


                                    <Button size="small" startIcon={<AddCircleIcon />} sx={{color:'black'}} variant="contained" color="secondary" onClick={handleSave}>
                                        Add Attributes
                                    </Button>


                                </Box>
                            </Box>


                            {/* 
                                </CardContent>
                            </Card> */}

                            <Divider sx={{ marginTop: '20px' }} />


                            <Box marginTop={1}>
                                <Typography variant="h6" sx={{ marginTop: '10px', marginBottom: '10px' }}> Material Attribute List</Typography>

                                <Box

                                    gridColumn="span 9"
                                    gridRow={"span 2"}
                                    alignItems="center"
                                    justifyContent="center"

                                    // height="51vh"
                                    sx={{

                                        "& .MuiCheckbox-root": {
                                            color: `${colors.greenAccent[200]} !important`,
                                        },
                                        "& .Muidropdown-root": {
                                            color: `${colors.greenAccent[200]} !important`,
                                        },

                                        borderLeft: "0", // Remove left border
                                        borderRight: "0", // Remove right border
                                    }}
                                >
                                    {/* <DataGrid name="dgv-orderselection" getRowId={(row) => row.id_material_shade} pageSize={5} columnHeaderHeight={35} rowHeight={40} rows={materialShade} columns={MaterialShadeColumns} */}
                                    <DataGrid rows={attributes} columns={columns} getRowId={(row) => row.id_attribute} autoHeight pageSize={5} columnHeaderHeight={35} rowHeight={40} />




                                </Box>
                            </Box>


                        </Grid>
                    </Grid>
                </Box>




            </DialogContent>
            <DialogActions style={{ backgroundColor: colors.primary[400] }}>

                <Button startIcon={<Cancel />} size="small" variant="outlined" color='error' onClick={onClose}>Close</Button>



            </DialogActions>
        </Dialog>
    );
};
export default AddUpdateMaterialAttributes;